import { MoneyFormat } from '@/domain/money'
import { Compensation } from './refund'

// Exchange is not refunded money and the status summary is not a method.
const REFUND_METHODS = [
  'bankTransfer',
  'originalPM',
  'promoCode',
  'giftCard'
] as const

type CompensationMoneyField = 'adjustments' | 'adjustedCommitment'

// Sums a money field across the refund methods, in the currency of the last one.
export function sumCompensation(
  compensation: Partial<Compensation>,
  field: CompensationMoneyField
): MoneyFormat {
  return REFUND_METHODS.reduce<MoneyFormat>(
    (total, method) => {
      const money = compensation[method]?.[field]
      if (!money) return total
      return {
        amount: (Number(total.amount) + Number(money.amount)).toString(),
        currency: money.currency
      }
    },
    { amount: '0', currency: 'EUR' }
  )
}
